// @givmo/app-admin — "Seed this fundraiser" CTA (EP-WEB3).
//
// On a PUBLISHED company fundraiser, navigates into the EP-WEB1 `/give` flow pre-targeted to this
// fundraiser with company funding (the give flow sends `funding_source="company"`). It reuses the
// existing company-funded fundraiser donation (a company seeding its own fundraiser is designed for —
// CAM-BE4-FR, no self-donation guard), so there is NO new backend surface.
//
// TWO gates: this CTA re-enters the direct-giving flow, so it renders ONLY when BOTH
// `isCompanyFundraisersEnabled()` AND `isCompanyDirectGivingEnabled()` are on (and only for a published
// fundraiser). Pre-selection rides a clean `?fundraiserId=` search param the give route reads.

import { useNavigate } from '@tanstack/react-router';
import { Button, Icon } from '@givmo/design-system';
import { Sprout } from 'lucide-react';
import { isCompanyDirectGivingEnabled, isCompanyFundraisersEnabled } from '../../lib/env';

export interface SeedFundraiserButtonProps {
  fundraiserId: string;
  /** Whether the fundraiser is published (Active). Only a live fundraiser is a valid donation target. */
  published: boolean;
}

export function SeedFundraiserButton({ fundraiserId, published }: SeedFundraiserButtonProps) {
  const navigate = useNavigate();
  // BOTH switches required: the CTA lands on /give, which is itself dark behind the direct-giving flag.
  if (!published) return null;
  if (!isCompanyFundraisersEnabled() || !isCompanyDirectGivingEnabled()) return null;
  return (
    <Button
      appearance="saas"
      tone="primary"
      leadingIcon={<Icon icon={Sprout} size={16} aria-hidden />}
      onClick={() => void navigate({ to: '/give', search: { fundraiserId } })}
      testId="company-fundraiser-seed"
    >
      Seed this fundraiser
    </Button>
  );
}
